import React from 'react';

import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import useViewportVisibility from 'hooks/use-viewport-visibility';
import { defaultFilters } from '../carousels.utils';
import { GenericCarousel } from './generic-carousel';

export function TopSellersCarousel(props) {
  const { ref, hasBeenVisible } = useViewportVisibility();

  const { loading, products } = useDispensaryProducts({
    filters: {
      ...defaultFilters,
      sortBy: `popular`,
      useCache: true,
    },
    perPage: 15,
    useBatch: true,
  });

  if (!products?.length && !loading && hasBeenVisible) {
    return null;
  }

  const sectionProps = {
    ...props,
    hasBeenVisible,
    isLoading: loading,
    label: `Top Sellers`,
    products,
  };

  return <GenericCarousel ref={ref} {...sectionProps} />;
}
